// Wallet networks supported by the platform. Both share the same EVM address.
export type WalletNetworkId = "Polygon (POS)" | "Ethereum (ERC20)";

export interface WalletNetwork {
  id: WalletNetworkId;
  label: string;
  labelEn: string;
  short: string;
  chainId: number;
  native: string;
  color: string;
  explorerTx: string;
  symbols: string[];
}

export const WALLET_NETWORKS: WalletNetwork[] = [
  {
    id: "Polygon (POS)",
    label: "محفظة Polygon",
    labelEn: "Polygon Wallet",
    short: "POLYGON",
    chainId: 137,
    native: "POL",
    color: "#8247E5",
    explorerTx: "https://polygonscan.com/tx/",
    symbols: [
      "POL", "WETH", "WBTC", "USDT", "USDC", "DAI", "STMATIC", "WSTETH", "AAVE",
      "LINK", "UNI", "CRV", "SUSHI", "MKR", "COMP", "BAL", "SNX", "GRT", "1INCH", "LDO",
    ],
  },
  {
    id: "Ethereum (ERC20)",
    label: "محفظة Ethereum (ERC20)",
    labelEn: "Ethereum Wallet (ERC20)",
    short: "ERC20",
    chainId: 1,
    native: "ETH",
    color: "#627EEA",
    explorerTx: "https://etherscan.io/tx/",
    symbols: [
      "ETH", "WETH", "WBTC", "USDT", "USDC", "DAI", "WSTETH", "AAVE",
      "LINK", "UNI", "CRV", "SUSHI", "MKR", "COMP", "BAL", "SNX", "GRT", "1INCH", "LDO",
    ],
  },
];

export const DEFAULT_WALLET_NETWORK: WalletNetworkId = "Polygon (POS)";

export function getWalletNetwork(id?: string | null): WalletNetwork {
  return WALLET_NETWORKS.find((n) => n.id === id) || WALLET_NETWORKS[0];
}

const POLYGON_ALIASES = new Set(["POLYGON (POS)", "POLYGON", "MATIC", "POL", "0X89", "137"]);
const ETHEREUM_ALIASES = new Set(["ETHEREUM (ERC20)", "ETHEREUM", "ERC20", "ETH", "0X1", "1"]);

/** Normalizes any stored network label onto one of the two wallet networks. */
export function normalizeWalletNetwork(network?: string | null): WalletNetworkId | null {
  const key = String(network || "").trim().toUpperCase();
  if (POLYGON_ALIASES.has(key)) return "Polygon (POS)";
  if (ETHEREUM_ALIASES.has(key)) return "Ethereum (ERC20)";
  return null;
}

export function isSymbolOnNetwork(symbol: string, networkId: string): boolean {
  return getWalletNetwork(networkId).symbols.includes(String(symbol || "").toUpperCase());
}
